import { Component, OnInit } from '@angular/core';
import { Debt, DebtsService } from 'src/app/shared/services/debts.service';

@Component({
  selector: 'app-debt-list',
  templateUrl: './debt-list.component.html',
  styleUrls: ['./debt-list.component.scss']
})
export class DebtListComponent implements OnInit {

  loading: boolean = false;
  debts: Debt[] = new Array<Debt>();
  exploratoryDebts: Debt[] = new Array<Debt>();

  constructor(private debtsSvc: DebtsService){

  }
  ngOnInit(): void {
    this.loading = true;
    this.debtsSvc.getDebts()
      .subscribe({
        next: (data: Debt[]) => {
          var aList = new Array<Debt>();
          var eList = new Array<Debt>();
          data.forEach((x, i) => {
            if(x.isExploratory == true) {
              eList.push(x);
            } else {
              aList.push(x);
            }
          });
          this.debts = aList;
          this.exploratoryDebts = eList;
          this.loading = false;
        }
      });
  }

}
